import * as Inovx from '@shared';
import LicenseServices from '../services/LicenseServices';
import LicenseConstants from '../constants/LicenseConstants';
import LicenseStore from '../stores/LicenseStore';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

function receiveAllLicenses(data: any): void {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: LicenseConstants.LICENSE_GET_ALL,
        data: data
    });
}

function receiveLicenseInfo(data: any): void {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: LicenseConstants.LICENSE_GET_INFO,
        data: data
    });
}

function _licenseFinishAdd() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: LicenseConstants.LICENSE_FINISH_ADD
    });
}

declare var InovxLoader: any;

var LicenseActions = {
    getAllLicenses: function (callback?: any, errorCallback?: any, ignoreDefaultError?: boolean): void {
        LicenseServices.getAllLicenses(function (data: any) {
            if (callback !== undefined && callback !== null) {
                callback();
            }
            receiveAllLicenses(data);
        },
            (error: IServiceErrorObject) => { if (errorCallback) errorCallback(error); },
            ignoreDefaultError);
    },

    getLicenseInfo: function (callback?: any, errorCallback?: any, ignoreDefaultError?: boolean): void {
        LicenseServices.getLicenseInfo(function (data: any) {
            if (callback) {
                callback();
            }
            receiveLicenseInfo(data);
        }, function (error: any) {
            if (errorCallback) {
                errorCallback(error);
                }
        },
        ignoreDefaultError);
    },

    beginAddLicense(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: LicenseConstants.LICENSE_BEGIN_ADD
        });
    },

    addingLicense(key: string, value: any): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: LicenseConstants.LICENSE_ADD_UPDATE,
            key: key,
            value: value
        });
    },

    create(callback?: any): void {
        if (!SystemStore.isActionInProgress(LicenseConstants.LICENSE_ADD)) {
            SystemActions.beginAction(LicenseConstants.LICENSE_ADD);

            LicenseServices.createLicense(LicenseStore.getEditLicense(),
                function () {
                    LicenseActions.refreshData();
                    if (callback !== undefined && callback !== null) {
                        callback();
                    }

                    _licenseFinishAdd();
                    SystemActions.endAction(LicenseConstants.LICENSE_ADD);
                },
                function () {
                    SystemActions.endAction(LicenseConstants.LICENSE_ADD);
                });
        }

    },

    finishAdd(): void {
        if (LicenseStore.getHasChanges()) {
            var callbackFunct = LicenseActions.create;
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: callbackFunct,
                cancelCallback: _licenseFinishAdd
            });
        } else {
            _licenseFinishAdd();
        }
    },

    refreshData() {
        LicenseActions.getAllLicenses();
    }
};

export default LicenseActions;
